
import { Box, Tooltip } from '@mui/material';
import React from 'react';
import { ActionAreaBtn } from './ActionAreaFab';
import { getUrlFaviconSrc } from '../common/util';

export interface EntryExternalLinkActionsProps {
	urls: string[];
}

/** One quick-action button per URL found in a selected entry's text fields, opening it in a new tab. */
export function EntryExternalLinkActions({ urls }: EntryExternalLinkActionsProps) {
	return <>
		{urls.map((url) => (
			<Tooltip key={url} title={`Open ${url}`} disableInteractive>
				<ActionAreaBtn onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}>
					<Box
						component='img'
						src={getUrlFaviconSrc(url)}
						alt=''
						sx={{ width: 24, height: 24, borderRadius: '3px' }}
					/>
				</ActionAreaBtn>
			</Tooltip>
		))}
	</>;
}
